import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BrowserOnly from 'components/consumer/BrowserOnly';
import PDPCylindo3dViewer from 'components/consumer/PDP/PDPCylindo3dViewer';
import PDPMobileCarousel from 'components/consumer/PDP/PDPMobileCarousel';
import MobileModal from 'components/consumer/MobileModal';
import PDPDimensionsContent from 'components/consumer/PDP/PDPDimensionsContent';
import PDPDecideLaterOverlay from 'components/consumer/PDP/PDPDecideLaterOverlay';
import usePDPGalleryInteractedEvent from 'data-hooks/useEvents/usePDPGalleryInteractedEvent';
import { GALLERY_IMAGE_LOCATION, GALLERY_INTERACTION } from 'data-hooks/useEvents/pdpGalleryEventConstants';
import PDPMobileConfigurationPhotoGallery3dViewer from './PDPMobileConfigurationPhotoGallery3dViewer';
import PDPMobileDimensionsIcon from '../PDPMobileDimensionsIcon';
const PDPMobileConfigurationPhotoGalleryUI = t0 => {
  const $ = _c(38);
  const {
    isEditOrder: t1,
    enableCrops: t2,
    photos: t3,
    productName,
    cylindoFeatures,
    isCylindoAvailable,
    showDecideLaterOverlay: t4,
    isConfigFlipped: t5,
    resetGalleryImageTracking,
    viewGalleryImageEvent,
    shouldShowDimensionThumbnail: t6,
    upholsteryKey
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const enableCrops = t2 === undefined ? true : t2;
  let t7;
  if ($[0] !== t3) {
    t7 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const photos = t7;
  const showDecideLaterOverlay = t4 === undefined ? false : t4;
  const isConfigFlipped = t5 === undefined ? false : t5;
  const shouldShowDimensionThumbnail = t6 === undefined ? false : t6;
  const [isDimensionsModalOpen, setIsDimensionsModalOpen] = useState(false);
  const [selectedCarouselIndex, setSelectedCarouselIndex] = useState(0);
  const {
    trackGalleryInteracted
  } = usePDPGalleryInteractedEvent();
  let t8;
  if ($[2] !== viewGalleryImageEvent) {
    t8 = position => viewGalleryImageEvent?.({
      imageLocation: GALLERY_IMAGE_LOCATION.MEASURE,
      position
    });
    $[2] = viewGalleryImageEvent;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const reportMeasureShotViewed = t8;
  let t9;
  if ($[4] !== isDimensionsModalOpen || $[5] !== reportMeasureShotViewed || $[6] !== resetGalleryImageTracking || $[7] !== trackGalleryInteracted) {
    t9 = () => {
      if (!isDimensionsModalOpen) {
        trackGalleryInteracted(GALLERY_INTERACTION.MEASURE_ACTIVATED);
        resetGalleryImageTracking?.();
        reportMeasureShotViewed(0);
      }
      setIsDimensionsModalOpen(true);
    };
    $[4] = isDimensionsModalOpen;
    $[5] = reportMeasureShotViewed;
    $[6] = resetGalleryImageTracking;
    $[7] = trackGalleryInteracted;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const openDimensionsModal = t9;
  let t10;
  if ($[9] !== cylindoFeatures || $[10] !== enableCrops || $[11] !== isConfigFlipped || $[12] !== isCylindoAvailable || $[13] !== isEditOrder || $[14] !== openDimensionsModal || $[15] !== photos || $[16] !== productName || $[17] !== selectedCarouselIndex || $[18] !== showDecideLaterOverlay || $[19] !== viewGalleryImageEvent) {
    t10 = isCylindoAvailable ? <BrowserOnly><PDPMobileConfigurationPhotoGallery3dViewer hidden={!isCylindoAvailable}><PDPCylindo3dViewer cylindoFeatures={cylindoFeatures} isMobile={true} /></PDPMobileConfigurationPhotoGallery3dViewer></BrowserOnly> : <PDPMobileCarousel isEditOrder={isEditOrder} enableCrops={enableCrops} photos={photos} productName={productName} showDecideLaterOverlay={showDecideLaterOverlay} setSelectedCarouselIndex={setSelectedCarouselIndex} selectedCarouselIndex={selectedCarouselIndex} onDimensionsIconClick={showDecideLaterOverlay ? _temp : openDimensionsModal} isConfigFlipped={isConfigFlipped} onAfterSlide={photo => {
      const position_0 = photos.findIndex(t11 => {
        const {
          src
        } = t11;
        return src === photo?.src;
      });
      if (position_0 !== -1) {
        viewGalleryImageEvent({
          imageLocation: GALLERY_IMAGE_LOCATION.CONFIGURATION,
          imageFilename: photo.src?.split("/").pop() || "",
          totalImages: photos.length,
          position: position_0
        });
      }
    }} />;
    $[9] = cylindoFeatures;
    $[10] = enableCrops;
    $[11] = isConfigFlipped;
    $[12] = isCylindoAvailable;
    $[13] = isEditOrder;
    $[14] = openDimensionsModal;
    $[15] = photos;
    $[16] = productName;
    $[17] = selectedCarouselIndex;
    $[18] = showDecideLaterOverlay;
    $[19] = viewGalleryImageEvent;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== showDecideLaterOverlay) {
    t11 = showDecideLaterOverlay && <PDPDecideLaterOverlay />;
    $[21] = showDecideLaterOverlay;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => {
      setIsDimensionsModalOpen(false);
    };
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== reportMeasureShotViewed || $[25] !== upholsteryKey) {
    t13 = <PDPDimensionsContent upholsteryKey={upholsteryKey} onDimensionShotViewed={reportMeasureShotViewed} />;
    $[24] = reportMeasureShotViewed;
    $[25] = upholsteryKey;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== isDimensionsModalOpen || $[28] !== t13) {
    t14 = <MobileModal isOpen={isDimensionsModalOpen} title="Dimensions" isFullHeight={true} onClose={t12}>{t13}</MobileModal>;
    $[27] = isDimensionsModalOpen;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== openDimensionsModal || $[31] !== shouldShowDimensionThumbnail) {
    t15 = shouldShowDimensionThumbnail && <div className="absolute right-4 top-4 z-[5] flex flex-col gap-2"><PDPMobileDimensionsIcon onClick={openDimensionsModal} /></div>;
    $[30] = openDimensionsModal;
    $[31] = shouldShowDimensionThumbnail;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t14 || $[36] !== t15) {
    t16 = <div className="relative min-h-[100vw]" data-xc="PDPMobileConfigurationPhotoGalleryUI">{t10}{t11}{t14}{t15}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
};
PDPMobileConfigurationPhotoGalleryUI.propTypes = {
  isEditOrder: PropTypes.bool,
  enableCrops: PropTypes.bool,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    src: PropTypes.string
  })),
  productName: PropTypes.string,
  isCylindoAvailable: PropTypes.bool,
  cylindoFeatures: PropTypes.arrayOf(PropTypes.string),
  showDecideLaterOverlay: PropTypes.bool,
  resetGalleryImageTracking: PropTypes.func,
  viewGalleryImageEvent: PropTypes.func,
  isConfigFlipped: PropTypes.bool,
  shouldShowDimensionThumbnail: PropTypes.bool,
  upholsteryKey: PropTypes.string
};
export default PDPMobileConfigurationPhotoGalleryUI;
function _temp() {}